import * as React from "react";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";

import { misc } from "app/themes/colors";

type PreferredValueWarningProps = {
  preferredValueTitle: string;
  patientPreferredValue: { id: number; name: string } | undefined;
  selectedValue: { id: number } | null;
  sx?: SxProps;
};

export default function PreferredValueWarning({
  patientPreferredValue,
  selectedValue,
  preferredValueTitle,
  sx
}: PreferredValueWarningProps) {
  if (
    selectedValue &&
    patientPreferredValue &&
    patientPreferredValue?.id !== selectedValue?.id
  ) {
    return (
      <Box sx={{ color: misc.warningText, ...sx }}>
        <Stack direction="row" spacing={0.25}>
          <WarningAmberIcon sx={{ height: 18 }} />
          <Stack>
            <Typography>
              The selected {preferredValueTitle} differs from the patient's
              preferred choice.
            </Typography>
            <Typography>
              Patient's Preferred: {patientPreferredValue.name}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }

  return null;
}
